var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[( _vm.currency === 'HKD' )?_c('span',[_vm._v("HKG:"+_vm._s(_vm.stkName.padStart(4, '0')))]):_c('span',[_vm._v(_vm._s(_vm.stkName))])])}
var staticRenderFns = []

export { render, staticRenderFns }